import { useDispatch } from "react-redux";
import { useApi } from "../apiCall/useApi";
import { useCallback, useState } from "react";
import {
  hidePageLoader,
  showPageLoader,
} from "../../reducers/Common/PageLoader/PageLoader.reducer";
import { Urls } from "../../../utils/constant";
import { setPatientList } from "../../reducers/Patient/patient.reducer";

// Columns: name, phone_no, email_id, age, gender (+ sr_no)
const COLUMN_LIST = [
  { field: "sr_no", headerName: "Sr. No.", flex: 1 },
  { field: "name", headerName: "Name", flex: 2 },
  { field: "phone_no", headerName: "Phone No.", flex: 2 },
  { field: "email_id", headerName: "Email", flex: 2 },
  { field: "age", headerName: "Age", flex: 1 },
  { field: "gender_val", headerName: "Gender", flex: 1 }, // 'Male'/'Female'/etc. (server should send string)
  // { field: 'status_val', headerName: 'Status', flex: 1 }, // optional if API returns it
];

export default function usePatient() {
  const dispatch = useDispatch();
  const { apiPost } = useApi();

  const [loading, setLoading] = useState(false);
  const [Name, setName] = useState("");

  const fetchPatientList = useCallback(
    async ({ current_page = 1, row_count = 10 }) => {
      if (loading) return;
      setLoading(true);
      try {
        dispatch(showPageLoader());

        const { data } = await apiPost({
          url: Urls.patientGet(), // <-- make sure this exists in your Urls
          data: {
            id: "",
            search_data: Name, // name filter
            // phone_no: '',     // add more filters later if needed
            // email_id: '',
            page_size: row_count,
            current_page: current_page,
            // status: 0,       // only if you add status filter
          },
        });

        // expects same paging envelope as Doctor API:
        // { current_page, page_size, has_more, total_page, total_count, data: [...] }
        dispatch(setPatientList(data));
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
        dispatch(hidePageLoader());
      }
    },
    [apiPost, dispatch, loading, Name]
  );

  const handleNameChange = useCallback((e) => {
    setName(e.target.value);
  }, []);

  return {
    gridHeaders: COLUMN_LIST,
    loading,
    Name,
    handleNameChange,
    fetchPatientList,
  };
}
